import styled from '@emotion/styled';
import { themed, ITheme } from '../../../themer';

export const DropdownItemHint = styled.div<{}, ITheme>`
	color: ${themed(({ dropdownList }) => dropdownList.option.hint.color)};
	margin-left: 6px;
`;
